export default "__VITE_ASSET__e9af860e__"